import { ComponentProps } from 'react'

import BreadcrumbItem from '@/modules/shared/components/breadcrumb/breadcrumb-item/BreadcrumbItem'

function BreadcrumbComponent(props: ComponentProps<'nav'>) {
  const { children, ...restProps } = props
  return (
    <nav aria-label="Breadcrumb" {...restProps}>
      <ol className="flex items-center overflow-y-auto hide-scrollbar">{children}</ol>
    </nav>
  )
}

export const Breadcrumb = Object.assign(BreadcrumbComponent, {
  Item: BreadcrumbItem,
})
